import { useGeneration } from '../../../context/GenerationContext';
import { Button } from '../../ui';
import { TrackList } from './TrackList';

export function ResultCard() {
  const { state, reset } = useGeneration();

  // Idle state
  if (state.status === 'idle') {
    return (
      <div className="flex flex-col items-center justify-center h-full text-center">
        <div className="text-6xl mb-4">🎵</div>
        <h3 className="text-xl font-semibold text-white mb-2">
          Ready to Generate
        </h3>
        <p className="text-spotify-text max-w-xs">
          Add some songs or describe your ideal playlist, then click Generate
          to create a new playlist powered by the Logic API.
        </p>
      </div>
    );
  }

  // Loading state
  if (state.status === 'loading') {
    return (
      <div className="flex flex-col items-center justify-center h-full text-center">
        <div className="w-16 h-16 border-4 border-spotify-green border-t-transparent rounded-full animate-spin mb-4" />
        <h3 className="text-xl font-semibold text-white mb-2">
          Generating Your Playlist...
        </h3>
        <p className="text-spotify-text max-w-xs">
          This may take a moment while we analyze and find the perfect tracks
          for you.
        </p>
      </div>
    );
  }

  // Error state
  if (state.status === 'error') {
    return (
      <div className="flex flex-col items-center justify-center h-full text-center">
        <div className="text-6xl mb-4">😕</div>
        <h3 className="text-xl font-semibold text-white mb-2">
          Something Went Wrong
        </h3>
        <p className="text-red-500 mb-4">{state.error}</p>
        <Button variant="secondary" onClick={reset}>
          Try Again
        </Button>
      </div>
    );
  }

  // Success state
  const result = state.result!;

  return (
    <div className="flex flex-col h-full min-h-0">
      <div className="flex-shrink-0">
        <h3 className="text-xl font-bold text-white mb-2">{result.title}</h3>
        <p className="text-spotify-text text-sm">{result.description}</p>
      </div>

      {/* Full Track List */}
      <div className="flex-1 min-h-0 overflow-y-auto my-4">
        <TrackList tracks={result.tracks} />
      </div>

      {/* Actions */}
      <div className="shrink-0">
        <Button
          as="a"
          href={result.playlist_url}
          target="_blank"
          rel="noopener noreferrer"
          className="w-full"
          size="lg"
        >
          Open in Spotify
        </Button>
      </div>

      {/* Not found tracks info */}
      {result.not_found && result.not_found.length > 0 && (
        <div className="pt-4 border-t border-gray-700 flex-shrink-0">
          <p className="text-spotify-text text-xs">
            {result.not_found.length} track(s) couldn't be found on Spotify
          </p>
        </div>
      )}
    </div>
  );
}
